export default function Error() {
  return (
    <div className="flex items-center justify-center h-full w-full">
      <div className="flex flex-col items-center justify-center">
        <h1 className="text-5xl font-bold text-gray-800">404</h1>
        <p className="text-lg text-gray-600">Page not found</p>
      </div>
    </div>
  );
}
